export default "__VITE_ASSET__C8Jeh2js__"